import { http } from '../api/http';

export interface AdminStatsResponse {
  totalCapital: number;
  activeProjects: number;
  totalUsers: number;
  conversionRate: number;
  totalCapitalChange?: string;
  activeProjectsChange?: string;
  totalUsersChange?: string;
  conversionRateChange?: string;
  totalUsersTrend?: 'positive' | 'negative' | 'neutral';
}

export type SystemSettingKey =
  | 'kyc_required'
  | 'pld_required'
  | 'maintenance_mode'
  | 'reports_enabled'
  | 'support_enabled'
  | 'blogs_enabled'
  | 'withdrawals_enabled'
  | 'investments_enabled'
  | 'developer_requests_enabled'
  | 'registrations_enabled';

export interface SystemSetting {
  key: SystemSettingKey;
  value: boolean;
  updatedAt?: string;
  updatedBy?: string;
}

export interface UpdateSystemSettingRequest {
  key: SystemSettingKey;
  value: boolean;
}

export const AdminService = {
  getStats() {
    return http<AdminStatsResponse>('/admin/stats');
  },

  getSystemSettings() {
    return http<SystemSetting[]>('/admin/system-settings');
  },

  getPublicSystemSettings() {
    return http<SystemSetting[]>('/public/system-settings', { auth: false });
  },

  updateSystemSetting(payload: UpdateSystemSettingRequest) {
    return http<SystemSetting>(`/admin/system-settings/${payload.key}`, {
      method: 'PUT',
      body: { value: payload.value }
    });
  }
};
